import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { workPlanAPI } from '../../services/api';
import toast from 'react-hot-toast';
import WorkPlanForm from './WorkPlanForm';
import WorkPlanList from './WorkPlanList';

const MyWorkPlan = () => {
  const { user } = useAuth();
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingPlan, setEditingPlan] = useState(null);
  const [filters, setFilters] = useState({
    dateFrom: '',
    dateTo: '',
    regionId: '',
    status: ''
  });

  useEffect(() => {
    fetchPlans();
  }, [filters]);

  const fetchPlans = async () => {
    try {
      setLoading(true);
      const params = {};
      if (filters.dateFrom) params.dateFrom = filters.dateFrom;
      if (filters.dateTo) params.dateTo = filters.dateTo;
      if (filters.regionId) params.regionId = filters.regionId;
      if (filters.status) params.status = filters.status;
      
      const response = await workPlanAPI.getAll(params);
      setPlans(response.data.data || []);
    } catch (error) {
      console.error('Error fetching work plans:', error);
      toast.error('Failed to load work plans');
    } finally {
      setLoading(false);
    }
  };

  const handleAddPlan = () => {
    setEditingPlan(null);
    setShowModal(true);
  };

  const handleEditPlan = (plan) => {
    setEditingPlan(plan);
    setShowModal(true);
  };

  const handleDeletePlan = async (id) => {
    if (!window.confirm('Are you sure you want to delete this work plan?')) return;
    
    try {
      await workPlanAPI.delete(id);
      toast.success('Work plan deleted successfully');
      fetchPlans();
    } catch (error) {
      console.error('Error deleting work plan:', error);
      toast.error('Failed to delete work plan');
    }
  };

  const handleSavePlan = async (planData) => {
    try {
      if (editingPlan) {
        await workPlanAPI.update(editingPlan.id, planData);
        toast.success('Work plan updated successfully');
      } else {
        await workPlanAPI.create(planData);
        toast.success('Work plan added successfully');
      }
      setShowModal(false);
      fetchPlans();
    } catch (error) {
      console.error('Error saving work plan:', error);
      toast.error(error.response?.data?.message || 'Failed to save work plan');
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-6">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Work Plan</h1>
          <p className="text-gray-600 mt-1">
            {user?.role === 'admin' ? 'All team work plans' : 'Planned calls grouped by date and status'}
          </p>
        </div>
        <button
          onClick={handleAddPlan}
          className="bg-teal-600 text-white px-4 py-2 rounded-lg hover:bg-teal-700 transition-colors flex items-center gap-2"
        >
          <i className="ti ti-plus" />
          New Plan
        </button>
      </div>

      <WorkPlanList
        plans={plans}
        loading={loading}
        onEdit={handleEditPlan}
        onDelete={handleDeletePlan}
        filters={filters}
        setFilters={setFilters}
        isAdmin={user?.role === 'admin'}
      />

      <WorkPlanForm
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSave={handleSavePlan}
        plan={editingPlan}
      />
    </div>
  );
};

export default MyWorkPlan;